// extracted by mini-css-extract-plugin
export default {"base":"vp_AV11M","divider":"vp_inlfe","text":"vp_k0_vI"};